import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-lib-multi-select',
  // imports: [CommonModule, FormsModule],
  // standalone: true,
  templateUrl: './lib-multi-select.component.html',
  styleUrl: './lib-multi-select.component.scss'
})
export class LibMultiSelectComponent implements OnChanges {
  placeholder= 'Select';
  searchTerm = ''
  isSearchable: false

  @Input() labelText = ''
  @Input() isReq = true
  @Input() noLabel = false
  @Input() isMultiSelect = false
  @Input() isSelectAllNeeded = false
  @Input() isDropdownOpen = false;
  @Output() toggleDropdown = new EventEmitter<void>();
  @Input() options: Array<{ id: number, name: string }> | string[] | string = [];
  @Input() selectedItems: any[] = [];
  
  // Local copy to avoid mutating input directly
  localSelectedItems: any[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedItems']) {
      this.localSelectedItems = [...this.selectedItems];
    }
  }

  get normalizedOptions(): Array<{ id: number, name: string }> {
    if (typeof this.options === 'string') {
      // If a single string is passed, treat as one option
      return [{ id: 0, name: this.options }];
    }
    if (Array.isArray(this.options)) {
      if (this.options.length === 0) return [];
      if (typeof this.options[0] === 'string') {
        // Array of strings
        return (this.options as string[]).map((name, idx) => ({ id: idx, name }));
      } else {
        // Array of objects
        return this.options as Array<{ id: number, name: string }>;
      }
    }
    return [];
  }
  @Output() selectionChange = new EventEmitter<string[]>();
  
  get formattedLabel(): string {
    return this.labelText.toLowerCase().replace(/\s+/g, '-');
  }

  // Select All / Deselect All logic
  toggleSelectAll() {
    const allOptionNames = this.filteredOptions.map(option => option.name);
    if (this.localSelectedItems.length === this.filteredOptions.length && this.filteredOptions.length > 0) {
      // Deselect all
      this.localSelectedItems = [];
    } else {
      // Select all
      this.localSelectedItems = [...allOptionNames];
    }
    this.selectionChange.emit(this.localSelectedItems);
  }

  isSelected(optionId: any): boolean {
    return this.localSelectedItems.includes(optionId);
  }

  toggleSelection(optionId: any) {
    if (!this.isMultiSelect) {
      // Single select mode: replace selection with new value
      this.localSelectedItems = [optionId];
      this.selectionChange.emit(this.localSelectedItems);
      // Close dropdown after selection in single select mode
      this.toggleDropdown.emit();
    } else {
      // Multi select mode: toggle selection
      if (this.isSelected(optionId)) {
        this.localSelectedItems = this.localSelectedItems.filter(id => id !== optionId);
      } else {
        this.localSelectedItems.push(optionId);
      }
      this.selectionChange.emit(this.localSelectedItems);
    }
  }

  get filteredOptions() {
    return this.normalizedOptions.filter(option =>
      option.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  clearSelection() {
    this.localSelectedItems = [];
    this.selectionChange.emit(this.localSelectedItems);
    this.isDropdownOpen = !this.isDropdownOpen
  }
}
